import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const state = {
    outlet_id: null,
    stockInventoryList: [],
};

const getters = {
    stockInventoryList(state) {
        return state.stockInventoryList;
    },

    outletId(state) {
        return state.outlet_id;
    },

    // to be removed
    getInventoryListByOutlet: state => outlet_id => {
        return state.stockInventoryList.filter(
            inventory => inventory.outlet_id === outlet_id,
        );
    },
};

const mutations = {
    [types.SET_STOCK_INVENTORY_LIST](state, stockInventoryList) {
        state.stockInventoryList = stockInventoryList;
    },

    [types.SET_OUTLET_ID](state, outlet_id) {
        state.outlet_id = outlet_id;
    },
};

const actions = {
    async getStockInventoryList({ commit, dispatch, state }, params = {}) {
        startLoading(dispatch, 'fetch-inventories');

        const url = Laroute.route('data_api.inventory_list');
        const options = {
            params: Object.assign(
                {
                    query: null,
                    outlet_id: state.outlet_id,
                    limit: 15,
                },
                params,
            ),
        };

        try {
            const { data } = await axios.get(url, options);

            commit(types.SET_STOCK_INVENTORY_LIST, data);
            endLoading(dispatch, 'fetch-inventories');
            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-inventories');
            throw e;
        }
    },

    setOutletId({ commit }, outlet_id) {
        commit(types.SET_OUTLET_ID, outlet_id);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/stock-inventory.js